module.exports = __webpack_public_path__ + "img/kikar-header.9a8d631f.svg";